import { GzProgressWebComponent } from './component/GzProgressWebComponent';
import { WEB_COMPONENT_GZ_PROGRESS } from '../../webcomponents.constants';

export { GzProgressWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_PROGRESS, GzProgressWebComponent);
